export const UploaderType = {
  DROPBOX: 'dropbox',
  LOCAL: 'local',
}
